import React from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaUserTie } from 'react-icons/fa';
import DeleteButton from '../editors/DeleteButton';

interface Testimonial {
  name: string;
  position: string;
  company: string;
  content: string;
  rating: number;
}

interface AboutTestimonialsSectionProps {
  language?: 'ar' | 'en';
  testimonials?: Testimonial[];
  onDeleteTestimonial?: (index: number) => void;
}

const AboutTestimonialsSection: React.FC<AboutTestimonialsSectionProps> = ({
  language = 'ar',
  testimonials = [
    {
      name: "أحمد محمد",
      position: "مدير مشروع",
      company: "شركة البناء الحديثة",
      content: "خبرة 11 عاماً تتحدث عن نفسها. شركة مكة البركة من أفضل شركات المقاولات في مصر. الجودة والالتزام بالمواعيد ممتاز.",
      rating: 5
    },
    {
      name: "سارة أحمد",
      position: "مدير تطوير",
      company: "مجموعة الاستثمار العقاري",
      content: "تعاملنا مع الشركة في عدة مشاريع وكانت النتائج مبهرة. الفريق محترف والجودة عالية جداً.",
      rating: 5
    },
    {
      name: "محمد علي",
      position: "رئيس مجلس إدارة",
      company: "شركة الطرق السريعة",
      content: "شركة مكة البركة شريك استراتيجي موثوق. نثق في خبرتهم وقدرتهم على تنفيذ المشاريع المعقدة.",
      rating: 5
    }
  ],
  onDeleteTestimonial
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">{isRTL ? 'شهادات العملاء' : 'Client Testimonials'}</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.2, duration: 0.5 }}
              viewport={{ once: true }}
              className="group relative bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl shadow-lg p-6"
            >
              {onDeleteTestimonial && (
                <DeleteButton onDelete={() => onDeleteTestimonial(idx)} />
              )}
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="w-5 h-5 text-yellow-400" />
                ))}
              </div>
              <p className="text-gray-700 mb-4 italic">"{testimonial.content}"</p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <FaUserTie className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.position}</div>
                  <div className="text-sm text-blue-600">{testimonial.company}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutTestimonialsSection; 